export const metricsHelper = (
    diagnosticsAwaiting: number,
    diagnostics: number,
    diagnosticsAwaitingCaseCount: number,
    diagnosticsCaseCount: number,
    treatmentPlanning: number,
    treatmentAwaiting: number,
    treatmentPlanningCaseCount: number,
    treatmentAwaitingCaseCount: number,
    underTreatment: number,
    underTreatmentCaseCount: number,
    underTreatmentProcedure: number,
    underTreatmentProcedureCaseCount: number,
    underDrugTreatment: number,
    underDrugTreatmentCaseCount: number,
    totalPostTreatmentCaseCount: number
) => [
    {
        group: 'Investigation',
        metrics: [
            {
                title: 'Diagnostics Awaiting',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle: 'Within 1-14 days from registration',
                currentMetricCaseCount: diagnosticsAwaitingCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: diagnosticsAwaiting,
            },
            {
                title: 'Under Diagnostics',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle: 'Within 28 days from registration',
                currentMetricCaseCount: diagnosticsCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: diagnostics,
            },
        ],
    },
    {
        group: 'Pre-Treatment',
        metrics: [
            {
                title: 'Treatment Planning',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle: 'Within 31 days from registration',
                currentMetricCaseCount: treatmentPlanningCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: treatmentPlanning,
            },
            {
                title: 'Treatment Awaiting',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle: 'Within 62 days from registration',
                currentMetricCaseCount: treatmentAwaitingCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: treatmentAwaiting,
            },
        ],
    },
    {
        group: 'Treatment',
        metrics: [
            {
                title: 'Under Treatment - Total',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle:
                    'Started within 62 days after registration',
                currentMetricCaseCount: underTreatmentCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: underTreatment,
            },
            {
                title: 'Under Treatment Procedure',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle:
                    'Started within 62 days after registration',
                currentMetricCaseCount: underTreatmentProcedureCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: underTreatmentProcedure,
            },
            {
                title: 'Under Drug Treatment',
                currentMetricsTitle: 'Cancer Care Timeline Compliance',
                currentMetricsSubtitle:
                    'Started within 62 days after registration',
                currentMetricCaseCount: underDrugTreatmentCaseCount,
                currentMetricsTarget: 90,
                currentMetricsPercentage: underDrugTreatment,
            },
        ],
    },
    {
        group: 'Post-Treatment',
        metrics: [
            {
                title: 'Under Post-Treatment Surveillance',
                currentMetricCaseCount: totalPostTreatmentCaseCount,
            },
        ],
    },
];
